import React from 'react'
import Pagination from '../../../../Components/Utils/Pagenation';
import ActivityCard from './ActivityCard';

function MobileActivityIndex({data,getData,total,pageIndex,setPageIndex,dataCount,setDataCount}) {
  return (
    <div className=' w-full h-[calc(100vh-160px)]'>
       <div className=' w-full h-[calc(100vh-192px)] overflow-y-auto py-1 px-2'>
        {
            data && data.map((item,index)=>{
                return(
                    <ActivityCard 
        getData={getData}
        item={item} key={index}/>
                )
            })
        }
        </div> 
       <div className=' w-full h-8'>
                <Pagination
                  total={total}
                  pageIndex={pageIndex}
                  setPageIndex={setPageIndex}
                  dataCount={dataCount}
                  setDataCount={setDataCount}
                />
        </div> 
    </div>
  )
}

export default MobileActivityIndex;